module.exports = "#p{\r\n    color:black;\r\n    font-weight: 900;\r\n   \r\n}\r\n"